import { render, staticRenderFns } from "./NavigationButtonComponent.vue?vue&type=template&id=366a3ffd&"
import script from "./NavigationButtonComponent.vue?vue&type=script&lang=ts&"
export * from "./NavigationButtonComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports